import React from 'react';
import Skeleton from '@atlaskit/skeleton';

export const ContentStateSkeleton = () => (
	<Skeleton width="60px" height="20px" isShimmering testId="content-state-skeleton" />
);
